export const cleanMarkdown = (content) => {
    return content.replace(/```markdown/g, '').replace(/```/g, '');
};